jQuery(($) => {
	if ($(".post-type-cell").length > 0) {
		$(".post-type-cell").on("click", function () {
			var url = $(this).data("url");
			window.location.href = url;
		});
	}
});
